import { Pie } from 'react-chartjs-2';

function PieChart({ data: dataParam = [] }) {
  /* {
    name: '',
    value: 32,
    color: '',
    background: '
  } */
  const data = {
    labels: dataParam.map((v) => v.name),
    datasets: [
      {
        data: dataParam.map((v) => v.value),
        backgroundColor: dataParam.map((v) => v.background),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      responsive: true,
      maintainAspectRatio: true,
      datalabels: {
        formatter: (value, dnct1) => {
          let sum = 0;
          const dataArr = dnct1.chart.data.datasets[0].data;
          dataArr.map((data) => {
            sum += Number(data);
          });

          const percentage = `${((value * 100) / sum).toFixed(0)}%`;
          if (percentage === 'NaN%' || percentage === '0%') {
            return '';
          }
          return percentage;
        },
        color(context) {
          const index = context.dataIndex;
          return dataParam[index]?.color;
        },
      },
    },
  };

  return (
    <div>
      <Pie data={data} options={options} />
    </div>
  );
}

export default PieChart;
